import React, { Fragment, useState, useEffect } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate } from "react-router";
import FAddressCard from "../../components/FAddressCard/FAddressCard";
import { getAddress, deleteAddressById } from "../../api/address";
import Floading from "../../components/Floading/Floading";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import FInputt from "../../components/FInputt/FInputt";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

const AddressDetailScreen = ({ param }) => {
  const parameters = useLocation();
  const address = [parameters.state];
  const {setLoading,checkToken } = useContext(AuthContext);

  const route = useNavigate();

  async function _deleteAddressById(AddressId) {
    checkToken()
    let _return = false;
    try {
      const dataDeleteAddressById = await deleteAddressById(AddressId);
      const res = dataDeleteAddressById.data;
      if (res.code == "PROCESS_OK") {
        route("/AddressScreen");
      }
    } catch (error) {
      const res = error.response.data;
      if (res.code == "NOT_FOUND") {
        // Swal.fire({
        //   title: "Código incorrecto",
        //   text: "",
        //   imageUrl: require("../../components/assets/images/advertir.png"),
        //   imageWidth: 150,
        //   imageHeight: 150,
        //   confirmButtonColor: "#fd6e0d",
        // });
      }
    }
    return _return;
  }

  return (
    <>
      <div className="px-5 grid place-items-center">
        <div className="w-[300px] sm:w-[484px] grid place-items-center">
          <FAddressCard arrayAddress={address} Responsive={false} />
          <FInputt
            type="botton"
            title={"Eliminar dirección"}
            className="bg-colorError mt-5 sm:w-[284px] cursor-pointer"
            onChange={() => {
              Swal.fire({
                showCloseButton: true,
                title: "Eliminar dirección",
                text: "¿Está seguro que desea eliminar esta dirección?",
                imageUrl: require("../../components/assets/images/pregunta.png"),
                imageWidth: 150,
                imageHeight: 150,
                imageAlt: "Custom image",
                confirmButtonColor: "#28a745",
                cancelButtonColor: "#dc3545",
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                reverseButtons: true,
              }).then((result) => {
                if (result.isConfirmed) {
                  _deleteAddressById(address[0].id);
                }
              });
            }}
          />
        </div>
      </div>
    </>
  );
};

export default AddressDetailScreen;
